export default "__VITE_ASSET__C3CW0iQQ__"